import axios from "axios";
import { reactive, ref } from "vue";
import { loading, errors, toast, meta, loadingBtn, remove } from "./shared";

export default function usePerson(navigation) {
  const persons = ref([]);
  const birthdays = ref([]);
  const person = reactive({
    account_id: "",
    numbers: [{ type: "mobile", value: "" }],
    billing: {},
    emails: [{ value: "" }],
    social: {},
    attachments: [],
    status: "new",
  });
  const { route, router } = navigation;
  const getPersons = async (query = {}) => {
    try {
      errors.value = "";
      if (query.inline) loadingBtn.value = true;
      else loading.value = true;
      const saerch = isObjectNotEmpty(query)
        ? "?" + new URLSearchParams(query).toString()
        : "";
      let response = await axios.get("user/person" + saerch);
      if (query.inline) loadingBtn.value = false;
      else loading.value = false;
      persons.value = response.data.data;
      Object.assign(meta, { ...response.data });
    } catch (e) {
      errors.value = e;
      if (query.inline) loadingBtn.value = false;
      else loading.value = false;
    }
  };

  const getPerson = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/person/" + route.params.id);
      loading.value = false;
      Object.assign(person, response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

   const getBirthdays = async (date) => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/person/birthday/date?start=" + date.start + "&end=" + date.end);
      loading.value = false;
      birthdays.value = response.data.data;
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const addPerson = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/person/create");
      loading.value = false;
      Object.assign(meta, { ...response.data });
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const editPerson = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get(
        "user/person/" + route.params.id + "/edit",
      );
      loading.value = false;
      Object.assign(person, response.data.data);
      Object.assign(meta, { ...response.data });
      if (
        person.industry &&
        meta.industries.indexOf((item) => item.title == person.industry) == -1
      )
        meta.industries.push({ title: person.industry });
      if (person.account)
        Object.assign(meta, { ["account"]: [person.account] });
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storePerson = async (modal = false) => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.post("user/person", person);
      progressDialog.value = false;
      toast.success(response.data.message);
      if (modal) document.getElementById(modal).checked = false;
      else router.push({ name: "user.persons" });
      return response.data.data;
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const updatePerson = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.put("user/person/" + route.params.id, person);
      progressDialog.value = false;
      toast.success(response.data.message);
      if (history.state.back) router.back();
      else router.push({ name: "user.persons" });
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const removePerson = async (modal = 'person-delete-modal') => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/person/" + remove.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById(modal).checked = false;
      if (modal && route.params.id) return response.data;
      else if (!modal && remove.single) {
        if (history.state.back) router.back();
        else router.push({ name: "user.persons" });
      } else getPersons(route.query);
      remove.single = false;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };
  return {
    persons,
    person,
    birthdays,
    getBirthdays,
    getPersons,
    getPerson,
    addPerson,
    editPerson,
    storePerson,
    updatePerson,
    removePerson,
  };
}
